<template>
        <v-list-tile class="" @click="">
  <v-list-tile-content>
    <v-list-tile-sub-title class="mb-2">{{ comment.user_full_name }} {{ comment.created_at | formatDate('LLL') }}</v-list-tile-sub-title>
    <div v-html="content" class="pa-3">
    </div>
  </v-list-tile-content>
  <v-list-tile-action v-if="comment.user === authUser.user">
      <rp-icon
        type="edit"
        tooltip="edytuj"
        @click="$emit('change-comment')"
      />
      <rp-icon
        type="delete"
        tooltip="usuń"
        @click="$emit('remove-comment')"
      />
  </v-list-tile-action>
        </v-list-tile>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['authUser']),
    content () {
      return this.comment.comment.replace(/\n/g, '<br>')
    }
  }
}
</script>
}
</script>



// WEBPACK FOOTER //
// src/plan/PlanComment.vue